import { APICore } from './apiCore';

const api = new APICore();

const toQuery = (q: any) => (q ? '?' + new URLSearchParams(q).toString() : '');

// ---- Yacht Management (Supplier API Spec) ----
export const listYachts = (q?: {
  status?: 'Draft' | 'Pending' | 'Approved' | 'Rejected';
  perPage?: number;
  page?: number;
  q?: string;
}) => api.get(`/supplier/yachts${toQuery(q)}`, {});

export const createYacht = (payload: any) => api.create('/supplier/yachts', payload);

export const getYacht = (id: number) => api.get(`/supplier/yachts/${id}`, {});

export const updateYacht = (id: number, payload: any) =>
  api.updatePatch(`/supplier/yachts/${id}`, payload);

export const deleteYacht = (id: number) => api.delete(`/supplier/yachts/${id}`);

export const submitYacht = (id: number, note?: string) =>
  api.create(`/supplier/yachts/${id}/submit`, note ? { note } : {});

// ---- Yacht Types (Supplier endpoint) ----
export const listYachtTypes = (q?: { lang?: string; active?: boolean; showInVendor?: boolean; page?: number; perPage?: number }) =>
  api.get(`/supplier/yacht-types${toQuery(q)}`, {});

// ---- Media Management ----
export const addYachtImages = (id: number, fileIds: number[]) =>
  api.create(`/supplier/yachts/${id}/images`, { fileIds });

export const updateYachtImage = (
  id: number,
  imageId: number,
  payload: { displayOrder?: number; isCover?: boolean }
) => api.updatePatch(`/supplier/yachts/${id}/images/${imageId}`, payload);

export const deleteYachtImage = (id: number, imageId: number) =>
  api.delete(`/supplier/yachts/${id}/images/${imageId}`);
